// extracted by mini-css-extract-plugin
export default {"description":"Fpxgf","textarea-container":"WiMlZ","textarea":"tymjm","container":"HwAZX"};